import React from 'react'

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


import img1 from '../../images/ASP_AMEN1.webp'
import img2 from '../../images/Basketball.webp'
import img3 from '../../images/GYM-1.webp'
import img4 from '../../images/ASP_AMEN2.webp'
import img5 from '../../images/ASP_AMEN3.webp'
import img6 from '../../images/ASP_AMEN4.webp'

// import img4 from '../../images/Swimming-pool.webp'


const Gallery = () => {

    const data = [
        {
            "id": 1,
            "image": img1
        },
        {
            "id": 2,
            "image": img2
        },
        {
            "id": 3,
            "image": img3
        },
        {
            "id": 4,
            "image": img4
        },
        {
            "id": 5,
            "image": img5
        },
        {
            "id": 6,
            "image": img6
        },
        {
            "id": 7,
            "image": "/amenities1.png"
        },
        {
            "id": 8,
            "image": "/amenities2.png"
        },
        {
            "id": 9,
            "image": "/amenities3.png"
        },
        {
            "id": 10,
            "image": "/amenities4.png"
        }
    ];

    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 2,
            partialVisibilityGutter: 90
        },
        mobile: {
            breakpoint: {
                max: 464,
                min: 0
            },
            items: 1,
            partialVisibilityGutter: 30
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 464
            },
            items: 2,
            partialVisibilityGutter: 30
        }
    };

    return (
        <div className='gallery-section mt-7 m-50'>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                autoPlay={true}
                centerMode
                className=""
                customTransition="all .5"
  transitionDuration={500}
                // containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={true}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {data.map((ele, i) => {
                    return (
                        <img key={i} src={ele.image} alt="" className='img-fluid w-100' style={{cursor : 'pointer', maxWidth: '90%', borderRadius: '11px'}} /> 
                        )
                })
                }
            </Carousel>


        </div>
    )
}

export default Gallery
